import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './outbound.actions.js';
import getters from './outbound.getters.js';
import mutations from './outbound.mutations.js';
import state from './outbound.state.js';

BaseStore.registerModule('outboundTransmissionsInspection', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('outboundTransmissionsInspection');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
